var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcess2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 132,
    viewBox: "0 0 179 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 132,
    rx: 19,
    fill: "#f5fbff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 132.1 20 H 42.9 C 40.8 20 38.8 20.8 37.3 22.3 C 35.8 23.8 35 25.8 35 27.9 V 100.2 C 35 102.2 35.8 104.2 37.3 105.7 C 38.8 107.2 40.8 108 42.9 108 H 55.3 C 55.7 108 56.1 107.8 56.4 107.6 C 56.7 107.3 56.8 106.9 56.8 106.5 C 56.8 106 56.7 105.6 56.4 105.3 C 56.1 105.1 55.7 104.9 55.3 104.9 H 42.9 C 41.6 104.9 40.4 104.4 39.5 103.5 C 38.6 102.6 38.1 101.4 38.1 100.2 V 40.2 H 112.8 C 113.2 40.2 113.6 40 113.9 39.7 C 114.2 39.4 114.3 39 114.3 38.6 C 114.3 38.2 114.2 37.8 113.9 37.5 C 113.6 37.2 113.2 37 112.8 37 H 38.1 V 27.9 C 38.1 26.6 38.6 25.4 39.5 24.5 C 40.4 23.6 41.6 23.1 42.9 23.1 H 132.1 C 133.4 23.1 134.6 23.6 135.5 24.5 C 136.4 25.4 136.9 26.6 136.9 27.9 V 37.1 H 118 C 117.6 37.1 117.2 37.3 116.9 37.6 C 116.6 37.9 116.4 38.2 116.4 38.7 C 116.4 39.1 116.6 39.5 116.9 39.8 C 117.2 40.1 117.6 40.2 118 40.2 H 136.9 V 100.2 C 136.9 100.8 136.8 101.4 136.5 102 C 136.3 102.6 135.9 103.1 135.5 103.6 C 135.1 104 134.5 104.3 134 104.6 C 133.4 104.8 132.8 104.9 132.1 104.9 H 60.5 C 60.1 104.9 59.7 105.1 59.4 105.4 C 59.1 105.7 58.9 106.1 58.9 106.5 C 58.9 106.9 59.1 107.3 59.4 107.6 C 59.7 107.9 60.1 108.1 60.5 108.1 H 132.1 C 133.2 108.1 134.2 107.9 135.2 107.5 C 136.1 107.1 137 106.5 137.7 105.8 C 138.4 105 139 104.2 139.4 103.2 C 139.8 102.3 140 101.2 140 100.2 V 27.9 C 140 25.8 139.2 23.8 137.7 22.3 C 136.2 20.8 134.2 20 132.1 20 Z",
    fill: "url(#paint0_linear_0_627)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 41.9 30.1 C 41.9 31.2 42.2 32.2 42.8 33.1 C 43.4 34 44.3 34.7 45.3 35.1 C 46.3 35.6 47.4 35.7 48.5 35.5 C 49.5 35.2 50.5 34.7 51.3 34 C 52.1 33.2 52.6 32.2 52.8 31.1 C 53 30.1 52.9 29 52.5 28 C 52.1 27 51.4 26.1 50.5 25.5 C 49.5 24.9 48.5 24.6 47.4 24.6 C 45.9 24.6 44.6 25.2 43.5 26.2 C 42.5 27.2 41.9 28.6 41.9 30.1 Z M 49.8 30.1 C 49.8 30.5 49.7 31 49.4 31.4 C 49.2 31.8 48.8 32.1 48.4 32.3 C 47.9 32.5 47.4 32.5 47 32.4 C 46.5 32.3 46.1 32.1 45.7 31.8 C 45.4 31.5 45.2 31 45.1 30.6 C 45 30.1 45 29.6 45.2 29.2 C 45.4 28.8 45.7 28.4 46.1 28.1 C 46.5 27.8 46.9 27.7 47.4 27.7 C 47.7 27.7 48 27.8 48.3 27.9 C 48.6 28 48.9 28.2 49.1 28.4 C 49.3 28.6 49.5 28.9 49.6 29.2 C 49.7 29.5 49.8 29.8 49.8 30.1",
    fill: "url(#paint1_linear_0_627)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 66.6 30.1 C 66.6 31.2 66.9 32.2 67.5 33.1 C 68.1 34 69 34.7 70 35.1 C 71 35.6 72.1 35.7 73.2 35.5 C 74.2 35.2 75.2 34.7 76 34 C 76.7 33.2 77.3 32.2 77.5 31.1 C 77.7 30.1 77.6 29 77.2 28 C 76.8 27 76.1 26.1 75.1 25.5 C 74.2 24.9 73.2 24.6 72.1 24.6 C 70.6 24.6 69.2 25.2 68.2 26.2 C 67.2 27.2 66.6 28.6 66.6 30.1 Z M 74.5 30.1 C 74.5 30.6 74.4 31 74.1 31.4 C 73.8 31.8 73.5 32.1 73 32.3 C 72.6 32.5 72.1 32.5 71.6 32.4 C 71.2 32.3 70.8 32.1 70.4 31.8 C 70.1 31.4 69.9 31 69.8 30.6 C 69.7 30.1 69.7 29.6 69.9 29.2 C 70.1 28.7 70.4 28.4 70.8 28.1 C 71.2 27.8 71.6 27.7 72.1 27.7 C 72.4 27.7 72.7 27.8 73 27.9 C 73.3 28 73.6 28.2 73.8 28.4 C 74 28.6 74.2 28.9 74.3 29.2 C 74.4 29.5 74.5 29.8 74.5 30.1 Z",
    fill: "url(#paint2_linear_0_627)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 54.2 30.1 C 54.2 31.2 54.6 32.2 55.2 33.1 C 55.8 34 56.6 34.7 57.6 35.1 C 58.6 35.6 59.7 35.7 60.8 35.5 C 61.9 35.2 62.8 34.7 63.6 34 C 64.4 33.2 64.9 32.2 65.1 31.1 C 65.3 30.1 65.2 29 64.8 28 C 64.4 27 63.7 26.1 62.8 25.5 C 61.9 24.9 60.8 24.6 59.7 24.6 C 58.3 24.6 56.9 25.2 55.8 26.2 C 54.8 27.2 54.2 28.6 54.2 30.1 Z M 62.1 30.1 C 62.1 30.6 62 31 61.7 31.4 C 61.5 31.8 61.1 32.1 60.7 32.3 C 60.2 32.5 59.7 32.5 59.3 32.4 C 58.8 32.3 58.4 32.1 58 31.8 C 57.7 31.4 57.5 31 57.4 30.6 C 57.3 30.1 57.3 29.6 57.5 29.2 C 57.7 28.7 58 28.4 58.4 28.1 C 58.8 27.8 59.3 27.7 59.8 27.7 C 60.4 27.7 61 27.9 61.4 28.4 C 61.9 28.8 62.1 29.4 62.1 30.1 Z",
    fill: "url(#paint3_linear_0_627)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 71 99.7 V 44.6 C 71 44.2 70.8 43.8 70.5 43.5 C 70.2 43.2 69.8 43 69.4 43 H 43.4 C 43 43 42.6 43.2 42.4 43.5 C 42.1 43.8 41.9 44.2 41.9 44.6 V 99.7 C 41.9 100.1 42.1 100.5 42.4 100.8 C 42.7 101.1 43.1 101.2 43.5 101.2 H 69.5 C 69.9 101.2 70.3 101.1 70.6 100.8 C 70.9 100.5 71 100.1 71 99.7 H 71 Z M 67.9 98.1 H 45 V 46.1 H 67.9 V 98.1 Z",
    fill: "url(#paint4_linear_0_627)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 76.5 69.5 H 131.6 C 131.8 69.5 132 69.5 132.2 69.4 C 132.4 69.3 132.5 69.2 132.7 69.1 C 132.8 68.9 132.9 68.7 133 68.5 C 133.1 68.4 133.1 68.2 133.1 67.9 V 44.6 C 133.1 44.2 133 43.8 132.7 43.5 C 132.4 43.2 132 43 131.6 43 H 76.5 C 76.3 43 76.1 43 75.9 43.1 C 75.7 43.2 75.5 43.3 75.4 43.5 C 75.2 43.6 75.1 43.8 75 44 C 75 44.2 74.9 44.4 74.9 44.6 V 67.9 C 74.9 68.1 75 68.4 75 68.5 C 75.1 68.7 75.2 68.9 75.4 69.1 C 75.5 69.2 75.7 69.3 75.9 69.4 C 76.1 69.5 76.3 69.5 76.5 69.5 Z M 78 46.1 H 130 V 66.4 H 78 V 46.1 Z",
    fill: "url(#paint5_linear_0_627)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 74.9 99.7 C 74.9 99.9 75 100.1 75 100.3 C 75.1 100.5 75.2 100.6 75.4 100.8 C 75.5 100.9 75.7 101 75.9 101.1 C 76.1 101.2 76.3 101.2 76.5 101.2 H 131.6 C 132 101.2 132.4 101.1 132.7 100.8 C 133 100.5 133.1 100.1 133.1 99.7 V 76.3 C 133.1 75.9 133 75.5 132.7 75.2 C 132.4 74.9 132 74.7 131.6 74.7 H 76.5 C 76.3 74.7 76.1 74.8 75.9 74.8 C 75.7 74.9 75.5 75 75.4 75.2 C 75.2 75.3 75.1 75.5 75 75.7 C 75 75.9 74.9 76.1 74.9 76.3 V 99.7 Z M 78 77.8 H 130 V 98.1 H 78 V 77.8 Z",
    fill: "url(#paint6_linear_0_627)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 49.9 54.5 H 63 C 63.4 54.5 63.8 54.4 64.1 54.1 C 64.4 53.8 64.5 53.4 64.5 53 C 64.5 52.6 64.4 52.2 64.1 51.9 C 63.8 51.6 63.4 51.4 63 51.4 H 49.9 C 49.5 51.4 49.1 51.6 48.8 51.9 C 48.5 52.2 48.3 52.6 48.3 53 C 48.3 53.4 48.5 53.8 48.8 54.1 C 49.1 54.4 49.5 54.5 49.9 54.5 Z",
    fill: "url(#paint7_linear_0_627)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 49.9 63.9 H 63 C 63.4 63.9 63.8 63.8 64.1 63.5 C 64.4 63.2 64.5 62.8 64.5 62.4 C 64.5 62 64.4 61.6 64.1 61.3 C 63.8 61 63.4 60.8 63 60.8 H 49.9 C 49.5 60.8 49.1 61 48.8 61.3 C 48.5 61.6 48.3 62 48.3 62.4 C 48.3 62.8 48.5 63.2 48.8 63.5 C 49.1 63.8 49.5 63.9 49.9 63.9 Z",
    fill: "url(#paint8_linear_0_627)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 49.9 73.3 H 63 C 63.4 73.3 63.8 73.2 64.1 72.9 C 64.4 72.6 64.5 72.2 64.5 71.8 C 64.5 71.4 64.4 71 64.1 70.7 C 63.8 70.4 63.4 70.2 63 70.2 H 49.9 C 49.5 70.2 49.1 70.4 48.8 70.7 C 48.5 71 48.3 71.4 48.3 71.8 C 48.3 72.2 48.5 72.6 48.8 72.9 C 49.1 73.2 49.5 73.3 49.9 73.3 Z",
    fill: "url(#paint9_linear_0_627)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 49.9 82.7 H 63 C 63.4 82.7 63.7 82.5 64 82.2 C 64.3 81.9 64.4 81.5 64.4 81.1 C 64.4 80.7 64.3 80.4 64 80.1 C 63.7 79.8 63.4 79.6 63 79.6 H 49.9 C 49.5 79.6 49.1 79.8 48.8 80.1 C 48.6 80.4 48.4 80.7 48.4 81.1 C 48.4 81.5 48.6 81.9 48.8 82.2 C 49.1 82.5 49.5 82.7 49.9 82.7 Z",
    fill: "url(#paint10_linear_0_627)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 49.9 92.1 H 63 C 63.4 92.1 63.8 91.9 64.1 91.6 C 64.4 91.3 64.5 90.9 64.5 90.5 C 64.5 90.1 64.4 89.7 64.1 89.4 C 63.8 89.1 63.4 89 63 89 H 49.9 C 49.5 89 49.1 89.1 48.8 89.4 C 48.5 89.7 48.3 90.1 48.3 90.5 C 48.3 90.9 48.5 91.3 48.8 91.6 C 49.1 91.9 49.5 92.1 49.9 92.1 Z",
    fill: "url(#paint11_linear_0_627)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 22 H 33 C 41.3 22 48 15.3 48 7 V 0 H 15 C 6.7 0 0 6.7 0 15 V 22 Z",
    fill: "#b5d336"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 131 132 H 164 C 172.3 132 179 125.3 179 117 V 110 H 146 C 137.7 110 131 116.7 131 125 V 132 Z",
    fill: "#b5d336"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_627",
    x1: 87.5,
    y1: 20,
    x2: 87.5,
    y2: 108.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#edc84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c6c45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91be6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_627",
    x1: 47.3702,
    y1: 24.5772,
    x2: 47.3702,
    y2: 35.5865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#edc84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c6c45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91be6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_627",
    x1: 72.122,
    y1: 24.5772,
    x2: 72.122,
    y2: 35.5865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#edc84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c6c45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91be6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_627",
    x1: 59.7405,
    y1: 24.5772,
    x2: 59.7405,
    y2: 35.5865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#edc84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c6c45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91be6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_627",
    x1: 56.4257,
    y1: 43.0065,
    x2: 56.4257,
    y2: 101.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#edc84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c6c45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91be6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_627",
    x1: 104.031,
    y1: 43.0065,
    x2: 104.031,
    y2: 69.5035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#edc84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c6c45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91be6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_627",
    x1: 104.031,
    y1: 74.7282,
    x2: 104.031,
    y2: 101.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#edc84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c6c45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91be6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_627",
    x1: 56.4257,
    y1: 51.4254,
    x2: 56.4257,
    y2: 54.5426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#edc84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c6c45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91be6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_627",
    x1: 56.4257,
    y1: 60.8102,
    x2: 56.4257,
    y2: 63.9275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#edc84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c6c45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91be6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_0_627",
    x1: 56.4257,
    y1: 70.195,
    x2: 56.4257,
    y2: 73.3123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#edc84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c6c45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91be6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_0_627",
    x1: 56.4256,
    y1: 79.5688,
    x2: 56.4256,
    y2: 82.6971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#edc84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c6c45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91be6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_0_627",
    x1: 56.4257,
    y1: 88.9536,
    x2: 56.4257,
    y2: 92.0709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcca46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#edc84b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c6c45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91be6d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess2);
export default __webpack_public_path__ + "static/media/process-2.f0a89b5b.svg";
export { ForwardRef as ReactComponent };